import u from '@/utils'
import Promise from 'bluebird'
import axios from 'axios'

let state = {
  identitiesLoading: false,
  identities: [],
  identityStructure: [],
  identifiedBots: {}
}

const getters = {}

const mutations = {
  setIdentitiesLoading(state, isLoading) {
    state.identitiesLoading = isLoading
  },
  setIdentities(state, identities) {
    state.identities = identities
  },
  updateIdentity(state, identity) {
    let index = state.identities.findIndex(
      item => item.hexId === identity.hexId
    )
    state.identities.splice(index, 1, identity)
  },
  setIdentityStructure(state, identityStructure) {
    state.identityStructure = identityStructure
  },
  setIdentifiedBots(state, payload) {
    state.identifiedBots = {
      ...state.identifiedBots,
      [payload.identity.hexId]: payload.bots
    }
  }
}

let actions = {
  async fetchIdentities({ commit }) {
    commit('setIdentitiesLoading', true)
    let response = await axios.get('/api/v1/identities?camundaId=false')
    let identities = [...response.data._embedded.identities]
    identities = identities.map(identity => u.processResp(identity))
    commit('setIdentities', identities)
    commit('setIdentitiesLoading', false)
    return identities
  },

  async deleteIdentity(context, identityHexId) {
    await axios.delete(`/api/v1/identities/${identityHexId}`)
  },

  async fetchIdentityStructure({ commit }) {
    let response = await axios.get('/api/v1/identities/identityStructure')
    let identityStructure = [...response.data._embedded.identityStructureModels]
    identityStructure = identityStructure.map(item => {
      item.options = item.options.sort((prev, curr) => {
        return prev.order > curr.order ? 1 : -1
      })
      return item
    })
    commit('setIdentityStructure', identityStructure)
  },

  async fetchIdentifiedBots({ commit }, identity) {
    let response = await axios.get(`/api/v1/identities/${identity.hexId}/bots`)
    let bots = [...response.data._embedded.bots]
    commit('setIdentifiedBots', { identity, bots })
  },

  async updateIdentity({ commit }, { body, hexId }) {
    let response = await axios.patch(`/api/v1/identities/${hexId}`, body)
    response.data = u.processResp(response.data)
    commit('updateIdentity', response.data)
    return response.data
  },

  async updateIdentityCredential({ commit }, { body, hexId, identityType }) {
    let response = await axios.patch(
      `/api/v1/identities/${hexId}/credentials/${identityType}`,
      body
    )
    response.data = u.processResp(response.data)
    commit('updateIdentity', response.data)
    return response.data
  },

  addBotToIdentity(context, payload) {
    return Promise.all(
      payload.bots.map(async bot => {
        let data = [`/api/v1/identities/${payload.identity.hexId}`].join('\n')
        let response = await axios.post(
          `/api/v1/bots/${bot.hexId}/identities`,
          data,
          {
            headers: {
              'Content-Type': 'text/uri-list'
            }
          }
        )
        return response.data
      })
    )
  },

  deleteBotFromIdentity(context, payload) {
    return Promise.all(
      payload.bots.map(bot => {
        return axios.delete(
          `/api/v1/bots/${bot.hexId}/identities/${payload.identity.hexId}`
        )
      })
    )
  },

  async saveIdentity(context, identityBody) {
    let response = await axios.post(`/api/v1/identities`, identityBody)
    return response.data
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
